<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      slim
      :name="`closingTimes[${index}].time`"
      rules="required"
    >
      <div>
        <v-text-field
          :id="`closing_times_${index}_time`"
          :value="value.time"
          :label="weekday.description"
          :name="`closingTimes[${index}].time`"
          readonly
          :error-messages="errors"
        >
          <template #prepend-inner>
            <font-awesome-icon :icon="['far', 'clock']"></font-awesome-icon>
          </template>
          <template #append-outer>
            <v-btn icon @click="$emit('copy', { time: value.time })">
              <font-awesome-icon icon="copy"></font-awesome-icon>
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </validation-provider>
    <v-menu
      ref="menu"
      v-model="showTimePicker"
      :close-on-content-click="false"
      offset-y
      max-width="290px"
      min-width="290px"
      :activator="`#closing_times_${index}_time`"
      @update:return-value="time => $emit('input', { ...value, time })"
    >
      <v-time-picker
        v-if="showTimePicker"
        v-model="value.time"
        ampm-in-title
        scrollable
        full-width
        @click:minute="$refs.menu.save(value.time)"
      >
      </v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "SortitionWeekdayScheduleRow",
  components: {
    ValidationProvider
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    weekday: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showTimePicker: false
    };
  }
};
</script>

<style scoped>
.v-text-field::v-deep .v-input__prepend-inner {
  margin-top: 8px;
}
</style>
